import React, { useState } from "react";
import { Attachment, Button, Checkbox, Col, DragDrop, HelpText, Input, Row, Slider, Toast, Tooltip } from "@kaleyra/emmy";
import { useTranslation } from "react-i18next";
import InfoIcon from '../../../../../../assets/info-icon-light.svg';
import Styles from './index.module.scss';

import { isEmpty } from "lodash";

export type MapStateType = {
};

export type DispatchPropsType = {
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => void;
    onFileUpload: (formData: any, callback: (resp: any, flag: boolean) => void) => void;
};

export type OwnProps = {
    onClose: () => void;
    getCreatedShortUrl: (url: string) => void
}

const sliderTabs = [
    { label: 'Enter Manually', value: 'manual' },
    { label: 'Upload File', value: 'upload' }
];

type sliderTabOptionType = "manual" | "upload";

const URLShortenerForm: React.FC<MapStateType & DispatchPropsType & OwnProps> = ({
    onSave, onClose, onFileUpload, getCreatedShortUrl }) => {
    const { t } = useTranslation();
    const [originalUrl, setOriginalUrl] = useState<string>("");
    const [urlTitle, setUrlTitle] = useState<string>("");
    const textlyLabel = process.env.REACT_APP_TEXTLY_LABEL || "";
    const [slug, setSlug] = useState<string>("");
    const [callbackUrl, setCallbackUrl] = useState<string>("");
    const [trackUserStatus, setTrackUserStatus] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<sliderTabOptionType>("manual");
    const [uploadedDocument, setUploadedDocument] = useState<any>([]);
    const [isFileAttached, setIsFileAttached] = useState<boolean>(false);
    const [fileName, setFileName] = useState('');

    const formatPostData = (): FormData => {
        let formDataOb = new FormData();
        formDataOb.append('url', originalUrl);
        formDataOb.append('url_title', urlTitle);
        if (!isEmpty(textlyLabel)) {
            formDataOb.append('label', textlyLabel);
        }
        if (!isEmpty(slug)) {
            formDataOb.append('slug', slug);
        }
        if (!isEmpty(callbackUrl)) {
            formDataOb.append('callback_url', callbackUrl);
        }
        if (isFileAttached) {
            formDataOb.append('attachment', "1");
            formDataOb.append('file_name', fileName);
        }
        formDataOb.append('is_advanced', trackUserStatus ? "on" : "off");
        return formDataOb;
    }

    const handleSaveCallback = (response: any, flag: boolean) => {
        if (flag) {
            Toast(t('BLD02003'), "success");
            getCreatedShortUrl && getCreatedShortUrl(response.data.shortLink);
            onClose();
        } else {
            Toast(response?.message, "error")
        }
    }

    const handleFormSave = () => {
        const postRequestBody = formatPostData();
        onSave(postRequestBody, handleSaveCallback);
    }

    const isURLValid = (url: string = ""): boolean => {
        //const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
        const urlRegex = /^[(http(s)?):\/\/(www\.)?a-zA-Z0-9:._-]{2,256}\.[a-z]{2,6}\b([[//][-a-zA-Z0-9@:%_\+.~#?&\\//=,]*)?$/ig;
        const result = urlRegex.test(url);
        return result;
    };

    const isTitleValid = (): boolean => {
        const titleRegex = /^[a-zA-Z0-9,.\-_ ]*$/gm;
        return urlTitle?.length !== 0 && urlTitle?.length <= 100 && (isURLValid(urlTitle) || titleRegex.test(urlTitle));
    }

    const isSlugValid = (): boolean => {
        const slugRegex = /^[A-Za-z0-9-]*$/;
        const result = slug.match(slugRegex);
        return (slug?.length === 0 || (slug.length <= 10 && result !== null));
    }

    const isCallbackURLValid = (): boolean => {
        return callbackUrl === undefined || callbackUrl?.length === 0 || isURLValid(callbackUrl);
    }

    const isFormValid = (): boolean => {
        return isURLValid(originalUrl) && isSlugValid() && isTitleValid() && isCallbackURLValid()
    }

    const renderTooltipBody = () => {
        return (
            <div className={Styles.tooltipBodyWrapper}>
                <span>{t('BLD02004')}</span>
                <span>{t('BLD02005')}</span>
            </div>
        )
    }

    const handleFileUpload = (res: any, flag: boolean) => {
        if (flag) {
            setOriginalUrl(res.data.url);
            Toast(res?.message, "success");
            setIsFileAttached(true);
            setFileName(res.data.title);
        } else {
            Toast(res?.message || t('chaEmptyPricing'), "error");
        }
    }

    const onFileSelect = (file: any, isValid: boolean) => {
        if (isValid) {
            const formData = new FormData();
            formData.append('file', file[0]);
            setUploadedDocument(file);
            onFileUpload(formData, handleFileUpload);
        } else {
            Toast(t('F104'), "error");
        }
    }

    const getFileType = (): string => {
        return uploadedDocument[0]?.name.split(".")[1];
    }

    const getFileName = (): string => {
        if (typeof (uploadedDocument) === "string") {
            return uploadedDocument;
        }
        if (uploadedDocument.length) {
            return uploadedDocument[0]?.name || "";
        }
        return uploadedDocument;
    }

    const onDeleteAttachment = () => {
        setUploadedDocument([]);
        setIsFileAttached(false);
        setOriginalUrl('')
        setFileName('');
    }

    const renderFormBody = () => {
        return (
            <>
                <div>
                    <Input label={t('BLD02007')} placeholder={t('BLD02007')} value={urlTitle} onChange={(e: any) => setUrlTitle(e.target.value)} bottomLabelType={(urlTitle?.length === 0 || isTitleValid() ? "default" : "error")} />
                </div>
                {activeTab === "upload" ?
                    <>
                        {isEmpty(uploadedDocument) || !isFileAttached ?
                            <div className={Styles.dragDropWrapper}>
                                <DragDrop fileFormats={'.jpg, .jpeg, .png, .pdf, .gif'} multiple={false} onChange={onFileSelect} />
                            </div> :
                            <>
                                <div className={Styles.attachmentWrapper}>
                                    <Attachment fileType={getFileType()} fileName={getFileName()} id={"id"} onClose={() => onDeleteAttachment()} />
                                </div>
                                {!isEmpty(originalUrl) && <div className={Styles.attachmentTextWrapper}>
                                    <HelpText type="draft" label={`${t('urlShortnerSuccessFileUploadLink')}: ${originalUrl}`} />
                                </div>}
                            </>
                        }
                    </> :
                    <div>
                        <Input label={t('BLD02006')} placeholder={t('BLD02006')} disabled={isFileAttached} value={originalUrl} onChange={(e: any) => setOriginalUrl(e.target.value)} bottomLabelType={(originalUrl?.length === 0 || isURLValid(originalUrl)) ? "default" : "error"} />
                    </div>}
                <div>
                    <span className={Styles.formLabel}>{t('BLD02010')}</span>
                    <Row className={Styles.twoColumnFormRow}>
                        <Col gutter size={6}>
                            <Input label={t('BLD02008')} disabled placeholder={t('BLD02008')} value={textlyLabel} />
                        </Col>
                        <Col size={6}>
                            <Input label={t('BLD02009')} placeholder={t('BLD02009')}
                                suffix={<Tooltip title={renderTooltipBody()} placement="left"><img src={InfoIcon}></img></Tooltip>}
                                value={slug} onChange={(e: any) => setSlug(e.target.value)}
                                bottomLabelType={slug.length === 0 || isSlugValid() ? "default" : "error"} />
                        </Col>
                    </Row>
                </div>
                <div>
                    <Input label={t('BLD02011')} placeholder={t('BLD02011')} value={callbackUrl} onChange={(e: any) => setCallbackUrl(e.target.value)} bottomLabelType={isCallbackURLValid() ? "default" : "error"} />
                </div>
                <Row>
                    <Col size={12}>
                        <Checkbox label={t('BLD02012')} className={Styles.checkbox} checked={trackUserStatus} onChange={(event: any) => setTrackUserStatus(event.target.checked)} />
                    </Col>
                </Row>
                <div className={Styles.footerPosition}>
                    <Button type="tertiary" onClick={onClose}>
                        {t('mainCancel')}
                    </Button>
                    <Button type="primary" onClick={() => handleFormSave()} disabled={!isFormValid()}>
                        {t('mainSave')}
                    </Button>
                </div>
            </>
        );
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            title={t('BLD02014')}
            tabs={sliderTabs}
            initActiveTab={activeTab}
            onTabClick={(tab: string) => setActiveTab(tab as sliderTabOptionType)}
        >
            <div className={Styles.container}>
                {renderFormBody()}
            </div>
        </Slider>
    )
}

export default URLShortenerForm;